import { render, staticRenderFns } from "./policy-contract.vue?vue&type=template&id=b51989ce"
import script from "./policy-contract.vue?vue&type=script&lang=js"
export * from "./policy-contract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports